import { HttpHeaders } from "@angular/common/http";
import { Component, Inject, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { finalize, catchError, throwError, Observable } from "rxjs";
import { HttpService } from "src/app/services/http.service";
import { UtilService } from "src/app/services/util.service";

export interface UserInvitation {
  id: number
  invitee_Id: string,
  inviter_Id: string,
  a_No: string,
  status: string,
  invitee_Email: string,
  inviter_Type: string,
  company_name: string,
  company_Address: string,
  inviterOrInviteeName: string,
  b_No: string,
  protesterCompanyName: string,
  inviterFirmName: string,
  consolidateBNumbers: string
}

interface Decision { invite_A_No: string, response: string }

@Component({
    selector: 'app-user-invitations',
    templateUrl: './user-invitations.component.html',
    standalone: false
})
export class UserInvitationsComponent {
  @ViewChild(MatTable) table!: MatTable<UserInvitation>;

  displayedColumns: string[] = ['aNo', 'protesterCompanyName', 'action'];
  dataSource!: MatTableDataSource<UserInvitation>;

  constructor(public dialogRef: MatDialogRef<UserInvitationsComponent>,
              @Inject(MAT_DIALOG_DATA) public data: UserInvitation[], private httpService: HttpService, private util: UtilService, private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<UserInvitation>();
    this.dataSource.data = this.data;
  }

  onYes(e: Event, row: UserInvitation) {
    e.stopPropagation();
    const decision = { invite_A_No: row.a_No, response: 'Y' };
    this.postDecision(decision);
  }

  onNo(e: Event, row: UserInvitation) {
    e.stopPropagation();
    this.util.displayDialogMessage("Confirmation",
      "Are you sure you want to reject the invitation from " + row.protesterCompanyName + " to join as a secondary representative?", { confirmText: 'Yes', cancelBtn: true, cancelText: 'No' })
      .pipe()
      .subscribe(res => {
        if (res) {
          const decision = { invite_A_No: row.a_No, response: 'reject' };
          this.postDecision(decision);
        }
      });
  }

  filterProcessed(decision: Decision) {
    let tableData = this.dataSource.data.filter(invite => invite.a_No != decision.invite_A_No);
    this.dataSource.data = [...tableData];
    if (this.dataSource.data && this.dataSource.data.length == 0) {
      this.util.displayDialogMessage("Success", "You have successfully accepted all pending invitations").pipe()
        .subscribe(res => {
          if (res) {
            this.dialog.closeAll();
          }
        });
    }
  }

  postDecision(decision: Decision) {
    const httpParams = this.httpService.createHttpParams(decision);
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { ...headers };
    this.httpService.Post<any>('/respond-to-invitation', httpParams, options).pipe(
      catchError(err => {
        return throwError(err);
      })
    ).subscribe(response => {
      console.log(response);
      this.filterProcessed(decision);
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
